import {
    BOOT_STATE_TYPE,
    IBootManager,
    TRANSITION_EVENT_TYPE,
} from '@src/js/service/boot-service/boot-manager.interface';
import PcInfrastructureReadyState from '@src/js/service/boot-service/boot-states-pc/pc-infrastructure-ready-state';
import PcFirstSlideRenderState from '@src/js/service/boot-service/boot-states-pc/pc-first-slide-render-state';
import PcFirstScreenLoadedState from '@src/js/service/boot-service/boot-states-pc/pc-first-screen-loaded-state';
import FSMTransition from '@src/slide/infrastructure/module/independent/state-machine/fsm-transition';
import FSMState from '@src/slide/infrastructure/module/independent/state-machine/fsm-state';
import FSMMachine from '@src/slide/infrastructure/module/independent/state-machine/fsm-machine';
import { IFSMMachine } from '@src/slide/infrastructure/module/independent/state-machine/state-machine.interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export const BOOT_STATE_MACHINE_PC = 'BootStateMachinePC';

export class BootManagerPC implements IBootManager {
    /**
     * 当前的启动状态
     */
    public bootStateMachine: IFSMMachine;

    public constructor() {
        this.initStateMachine();
        this.registerEvent();
    }

    private initStateMachine() {
        const notInitState = new FSMState(BOOT_STATE_TYPE.notInit);
        const initState = new FSMState(BOOT_STATE_TYPE.init);
        const infrastructureDidReadyState = new PcInfrastructureReadyState();
        const firstSlideDidRenderState = new PcFirstSlideRenderState();
        const firstScreenDidLoadState = new PcFirstScreenLoadedState();
        notInitState.addTransition(new FSMTransition(TRANSITION_EVENT_TYPE.didInitEvent, notInitState, initState));
        initState.addTransition(new FSMTransition(
            TRANSITION_EVENT_TYPE.infrastructureDidReadyEvent,
            initState, infrastructureDidReadyState,
        ));
        infrastructureDidReadyState.addTransition(new FSMTransition(
            TRANSITION_EVENT_TYPE.firstSlideDidRenderEvent,
            infrastructureDidReadyState, firstSlideDidRenderState,
        ));
        firstSlideDidRenderState.addTransition(new FSMTransition(
            TRANSITION_EVENT_TYPE.firstScreenDidLoadEvent,
            firstSlideDidRenderState, firstScreenDidLoadState,
        ));
        this.bootStateMachine = new FSMMachine(BOOT_STATE_MACHINE_PC);
        this.bootStateMachine.addState(notInitState);
        this.bootStateMachine.addState(initState);
        this.bootStateMachine.addState(infrastructureDidReadyState);
        this.bootStateMachine.addState(firstSlideDidRenderState);
        this.bootStateMachine.addState(firstScreenDidLoadState);
    }

    private registerEvent() {
        this.bootStateMachine.executeByEvent(TRANSITION_EVENT_TYPE.didInitEvent);
        eventBus.onIncludingPast(EventKeys.FIRST_PAGE_DISPLAY, () => {
            this.bootStateMachine.executeByEvent(TRANSITION_EVENT_TYPE.firstSlideDidRenderEvent);
        });
        eventBus.onIncludingPast(EventKeys.VISIBLE_PAGE_DISPLAY, () => {
            this.bootStateMachine.executeByEvent(TRANSITION_EVENT_TYPE.firstScreenDidLoadEvent);
        });
    }
}

export const PCBootManager = new BootManagerPC();
